import type { Event } from "event/types/event.model";
import { DEFAULT_WHITE_COLOR } from "../../../_graphic_design";

export function EventDate({
  event,
  className,
}: {
  event: Event;
  className: string;
}) {
  const localClassNames = `flex flex-col leading-4 ml-2 text-xs capitalize`;
  const classNames =
    className && className !== ""
      ? `${className} ${localClassNames}`
      : localClassNames;
  return (
    <div
      className={classNames + " font-bold"}
      style={{
        color: event.colors?.headerEventDateText ?? DEFAULT_WHITE_COLOR,
      }}
    >
      <span>
        {new Date(event.kickoff_date).toLocaleString(undefined, {
          weekday: "long",
        })}
      </span>
      <span>
        {new Date(event.kickoff_date).toLocaleString(undefined, {
          day: "numeric",
          month: "numeric",
          year: "2-digit",
        })}
      </span>
    </div>
  );
}
